/**
 * Indexa, por agente, os times de que ele já participa e as inboxes que ele
 * atende em cada um deles.
 *
 * Um agente pode pertencer a N times (inclusive times que dividem a mesma
 * inbox). Este índice existe só para AVISAR na tela de seleção quando essa
 * sobreposição acontecer — nunca para bloquear a inclusão.
 *
 * `member.id` no retorno da API de team_members é o user_id, e cada linha
 * carrega o `inbox_id` daquela membership.
 *
 * @param {Array<{team: {id: number, name: string}, members: Array<{id: number, inbox_id: number}>}>} teamsWithMembers
 * @returns {Object<number, Array<{id: number, name: string, inboxIds: number[]}>>}
 */
export function buildAgentTeamsIndex(teamsWithMembers) {
  const index = {};

  teamsWithMembers.forEach(({ team, members }) => {
    members.forEach(member => {
      const userId = member.id;

      if (!index[userId]) {
        index[userId] = [];
      }

      let entry = index[userId].find(item => item.id === team.id);
      if (!entry) {
        entry = { id: team.id, name: team.name, inboxIds: [] };
        index[userId].push(entry);
      }

      if (member.inbox_id && !entry.inboxIds.includes(member.inbox_id)) {
        entry.inboxIds.push(member.inbox_id);
      }
    });
  });

  return index;
}
